import { getIndexerValueForMailboxInfo, type MailboxInfo } from "owa-client-types";
import getStore from "../store/store";

export default function areNotificationsEnabledForAccount(mailboxInfo: MailboxInfo): boolean {
    // Return true if the account index is not in the list of accounts with disabled notifications
    return !getStore().global?.accountsNotifsDisabled?.includes(getIndexerValueForMailboxInfo(mailboxInfo).toLowerCase());
}
